module.exports = __webpack_public_path__ + "img/uber_and_asu_logo.99a7f49f.svg";